import './App.css';
import {Component,} from 'react';
import {MemoryRouter as Router, Route, Routes} from 'react-router-dom';
import Footer from './Footer';
import OutdoorPlaningMap from "./outdoor/OutdoorPlaningMap";
import OutdoorPlaningCalculation from "./outdoor/OutdoorPlaningCalculation";
import OutdoorTrafficModelSubmission from "./outdoor/OutdoorTrafficModelSubmission";
import OutdoorPlaningRequest from "./outdoor/OutdoorPlaningRequest";
import OutdoorExit from "./outdoor/OutdoorExit";
import classes from "./files/classes.csv";
import OutdoorHouseSelection from "./outdoor/OutdoorHouseSelection";
import {PrimeReactProvider} from "primereact/api";
import LandingPage from './LandingPage';
import Impressum from './impressum';
import Datenschutz from './datenschutz';
import ExampleCampus from './outdoor/ExampleCampus';


class App extends Component {
    /*
    * this.image = variable for the image used in  OutdoorPlaningCalculation created in OutdoorPlaningMap
    * this.state = two state indices for the indoor/outdoor routine
    * set functions = functions for the child files to change the parent variables
    * */
    constructor(props) {
        super(props);
        this.setPolygon = this.setPolygon.bind(this);
        this.getPolygon = this.getPolygon.bind(this);
        this.setArea = this.setArea.bind(this);
        this.getArea = this.getArea.bind(this);
        this.setImage = this.setImage.bind(this);
        this.getImage = this.getImage.bind(this);
        this.setJson = this.setJson.bind(this);
        this.setUuid = this.setUuid.bind(this);
        this.getUuid = this.getUuid.bind(this);
        this.landingFooter = this.landingFooter.bind(this);
    }

    render() {
        var tempClassArray = []
        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'text/plain; charset=UTF-8');
        fetch(classes, myHeaders).then(
            r => r.arrayBuffer()
        ).then(
            t => {
                const decoder = new TextDecoder("iso-8859-1")
                let text = decoder.decode(t)
                let tt = text.split("\n")
                for (let i = 0; i < tt.length - 1; i++) {
                    let temp = tt[i].split(",")
                    tempClassArray[i] = {key: temp[0], label: temp[1]}
                }
                //localStorage.setItem("classArray", JSON.stringify(tempClassArray))
            })
        // if the main site ist called
        let start = 0 //6
        if (window.location.pathname === "/") {
            start = 0
        } else if (window.location.pathname === "/campusgelaende") {
            start = 1
        } else if (window.location.pathname === "/logistiklager") {
            start = 2
        } else if (window.location.pathname === "/impressum") {
            start = 3
        } else if (window.location.pathname === "/datenschutz") {
            start = 4
        } //else if (window.location.pathname === "/safe") {
            // start = 5
        // } 
        return (
            <PrimeReactProvider>
                <Router initialEntries={["/", "/campusgelaende", "/logistiklager", "/impressum", "/datenschutz"]}
                        initialIndex={start}>
                    <Routes>
                        <Route path={"/campusgelaende"} element={
                            <div>
                                <ExampleCampus example_id={1}/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        <Route path={"/logistiklager"} element={
                            <div>
                                <ExampleCampus example_id={0}/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        <Route  path={"/:uuid"} element={
                            <div>
                                <OutdoorPlaningRequest/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        {/*<Route path={"/"} element={<Home/>}/>
                    <Route exact path={"/indoor"} element={
                        <div>
                            <div className={'my-5 py-5 fa-10x'}>We are Indoor!!</div>
                            <Footer/>
                        </div>}/>*/}
                        <Route path={"/"} element={
                            <div>
                                <LandingPage/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        <Route path={"/impressum"} element={
                            <div>
                                <Impressum/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        <Route path={"/datenschutz"} element={
                            <div>
                                <Datenschutz/>
                                <this.landingFooter/>
                            </div>
                        }/>
                        <Route path={"/safe"} element={
                            <div>
                                <OutdoorPlaningMap setArea={this.setArea} setPolygon={this.setPolygon}
                                                   setImage={this.setImage}/>
                                <Footer disable={true} nextPage={"/outdoor/calculation"}/>
                            </div>
                        }/>
                        <Route exact path={"/outdoor/calculation"} element={
                            <div>
                                <OutdoorPlaningCalculation getArea={this.getArea} getImage={this.getImage}
                                                           setJson={this.setJson}/>
                                <Footer disable={false} nextPage={"/outdoor/house"}/>
                            </div>
                        }/>
                        <Route exact path={"/outdoor/house"} element={
                            <div>
                                <OutdoorHouseSelection setJson={this.setJson} setUuid={this.setUuid}/>
                                <Footer disable={false} nextPage={"/outdoor/traffic"}/>
                            </div>
                        }/> <Route exact path={"/outdoor/traffic"} element={
                        <div>
                            <OutdoorTrafficModelSubmission setJson={this.setJson} setUuid={this.setUuid}/>
                            <Footer disable={false} nextPage={"/outdoor/exit"}/>
                        </div>
                    }/>
                        <Route exact path={"/outdoor/exit"} element={<OutdoorExit getUuid={this.getUuid}/>}/>
                    </Routes>
                </Router>
            </PrimeReactProvider>
        )
    }

    setJson(json) {
        localStorage.setItem("json", JSON.stringify(json))
    }

    setArea(area) {
        this.area = area;
    }

    getArea() {
        return this.area;
    }

    setImage(image) {
        this.image = image;
    }

    getImage() {
        return this.image;
    }

    setPolygon(polygon) {
        localStorage.setItem("polygon", JSON.stringify(polygon.getLatLngs()[0]))
        this.polygon = polygon;
    }

    getPolygon() {
        return this.polygon
    }

    setUuid(uuid) {
        this.uuid = uuid;
    }

    getUuid() {
        return this.uuid;
    }

    landingFooter = () => {
        return(
            <footer style={{
                backgroundColor: '#2BA3B6',
                color: 'white',
                padding: '25px 0 25px 0',
                textAlign: 'center',
                marginTop: 'auto'
            }}>
                <div className="container">
                    <p className="fs-5" style={{ marginBottom: '0.3rem' }}> Copyright © 2025 Competence Center 5G.NRW, TU Dortmund - Lehrstuhl für Kommunikationsnetze</p>
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <div className="row w-25">
                            <a href="/impressum" className="col-6" style={{color: "white" ,textDecoration: "none"}}>Impressum</a>
                            <a href="/datenschutz" className="col-6" style={{color: "white" ,textDecoration: "none"}}>Datenschutz</a>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default App;
